/**
 * This file is for development only and is used to simulate flags without the need
 * to use or have access to the split.io web console.
 *
 * To develop against a flag, declare it in this file and export the flags object.
 *
 * To disable development mode, export false.
 *
 * For more information see:
       https://www.familysearch.org/frontier/docs/develop/feature-flags#creating-a-new-feature-flag
 */

// eslint-disable-next-line no-unused-vars
const flags = {
  // Flags that are basically permanent or long term
  give_bad_actor: {
    config: {
      checkForBigEditDistance: { enabled: true, threshhold: 3 },
      checkForSanitizedCharacters: { enabled: true },
      checkForTooManySpaces: { enabled: true, threshhold: 3 },
      checkForSequentialEdits: { enabled: true, threshhold: 3 },
      checkForProfanity: { enabled: true },
      checkForEditSpam: { enabled: true, threshhold: 3 },
      checkForHighlightCollisions: { enabled: true, threshhold: 3 },
      checkForExtraneousHighlights: { enabled: true, threshhold: 3 },
      checkForTooSmallHighlighst: { enabled: true, threshhold: 3 },
    },
    treatment: 'on',
  },
  rip_sharedImageViewer_saveChanges: { treatment: 'on' },
  shared_dasProxy: { treatment: 'off' }, // Long term
  rip_sharedImageViewer_feedback_FamilyReview: { treatment: 'on' },
  rip_sharedImageViewer_feedback_RII: { treatment: 'on' },
  give_corrections: { treatment: 'set-me' }, // in-prison or inmate
  // basically indexing on the fly on records that have not been indexed at all
  lightyear_sharedImageViewer_indexedPercentage: { treatment: 'on' },
  lightyear_sharedImageViewer_provisionalPlacesInCoverages: { treatment: 'off' },
  rip_sharedImageViewer_1931CensusEdit: { treatment: 'on' },
  rip_sharedImageViewer_ShowPromptDetails: { treatment: 'off' },
  rip_sharedImageViewer_flaggedUserDetection_: {
    config: {
      intervalInSeconds: 6,
      spamCountWithinInterval: 10,
      matchCumulativeThreshold: 20,
      notPersonCumulativeThreshold: 6,
    },
    treatment: 'off',
  },
  rip_familyReview_advancedRecordDetection: { treatment: 'off' },
  rip_sharedImageViewer_attachTreePrompt: { treatment: 'on' },
  rip_sharedImageViewer_reassignHighlightFlow: { treatment: 'on' },
  rip_sharedImageViewer_sharedEventPanel: { treatment: 'on' },
  rip_sharedImageViewer_collectionTracking: { treatment: 'off' },
  rip_sharedImageViewer_linkExistingEvent: { treatment: 'off' },
  rip_sharedImageViewer_enableFullTextTutorial: { treatment: 'off' },
  rip_sharedImageViewer_showJiapu: { treatment: 'on' },
  rip_sharedImageViewer_sls_actions_splunk_debugger: { treatment: 'off' },
  rip_sharedImageViewer_azure41StreamingPrompt: { treatment: 'off' },
  rip_sharedImageViewer_autoIndexing: { treatment: 'on' },
  frontier_zion_newSessionEndpoint: { treatment: 'on' },
  frontier_zion_newPermissionsEndpoint: { treatment: 'on' },
  rip_sharedImageViewer_fullTextAttachFlow_v1: { treatment: 'on' },
  rip_sharedImageViewer_fullTextAttachFlow_v2: { treatment: 'off' },
  rip_sharedImageViewer_fullTextAttachFlowOptIn: { treatment: 'off' },
  rip_sharedImageViewer_showTranscriptEditButton: { treatment: 'off' },
  rip_sharedImageViewer_fullTextSplitScreenButton: { treatment: 'off' },
  rip_sharedImageViewer_transcriptFromStuffRecords: { treatment: 'off' },
  rip_sharedImageViewer_highlightsVisibility: { treatment: 'off' },
}

// export default flags
export default false

export const badActorFlag = flags.give_bad_actor
